export default __webpack_public_path__ + "static/media/Neddie-Screen-7.82fb7a7c.png";